import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import { CatalogueProvider, SingleProductProvider } from 'contexts';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { ColorsList } from './components/ColorsList';
import { ProductList } from './components/ProductList';
import { SingleProduct } from './components/SingleProduct';

export function CataloguePage(): React.ReactElement {
  const [isGridChange, isGridChangeSet] = useState<boolean>(false);

  return (
    <DefaultLayout withHeader isGridChange={isGridChange}>
      <Routes>
        <Route path="/:genre/:category">
          <Route element={<CatalogueProvider />}>
            <Route index element={<ProductList isGridChangeSet={isGridChangeSet} />} />

            <Route path=":id">
              <Route
                index
                element={
                  <SingleProductProvider>
                    <SingleProduct />
                  </SingleProductProvider>
                }
              />

              <Route path="list" element={<ColorsList isGridChangeSet={isGridChangeSet} />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </DefaultLayout>
  );
}
